<template>
  <div>
    <el-form-item :label="language('shopInformation.contactName')">
      <div class="input">
        <el-input v-model="form['contactName']"></el-input>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.contactPhone')">
      <div class="input">
        <el-input v-model="form['contactPhone']"></el-input>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.contactEmail')">
      <div class="input">
        <el-input v-model="form['contactEmail']"></el-input>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.serviceCentreAddress')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['serviceCentreAddress']"
          :maxlength="100"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 100 ' +
            language('shopInformation.words') +
            tips(form['serviceCentreAddress'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.serviceCentreAddressEng')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['langList'][0].value"
          :maxlength="200"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 200 ' +
            language('shopInformation.words') +
            tips(form['langList'][0].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  model: {
    prop: "forms",
    event: "change",
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      nameArr: ["serviceCentreAddress"],
      form: {
        langList: [
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "serviceCentreAddress", //字段
            appId: "supnr",
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.$emit("change", this.form);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    tips(text) {
      if (text) {
        return (
          this.language("shopInformation.maxTips1") +
          text.length +
          this.language("shopInformation.maxTips2")
        );
      }
      return "";
    },
  },
  mounted() {
    if (this.formData.id) {
      let langList = [];
      for (let i = 0; i < this.formData.langList.length; i++) {
        if (this.nameArr.indexOf(this.formData.langList[i].name) > -1) {
          langList.push(this.formData.langList[i]);
        }
      }
      if (this.formData.langList.length == 0) {
        langList = [
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "serviceCentreAddress", //字段
            appId: "supnr",
          },
        ];
      }
      this.form = {
        langList: langList,
        contactName: this.formData.contactName,
        contactPhone: this.formData.contactPhone,
        contactEmail: this.formData.contactEmail,
        serviceCentreAddress: this.formData.serviceCentreAddress,
      };
      this.$emit("change", this.form);
    } else {
    }
  },
};
</script>
<style>
.el-alert {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
<style scoped>
.input {
  width: 400px;
}
</style>